var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('key-value-table',{attrs:{"name":"game","api":("/api/history/games/" + _vm.id),"headers":_vm.headers},scopedSlots:_vm._u([{key:"account.user.name",fn:function(ref){
var user = ref.item.account.user;
return [_c('user-profile-modal',{attrs:{"user":user}})]}},{key:"gameable.deck",fn:function(ref){
var gameable = ref.item.gameable;
return [_vm._l((gameable.deck.slice(0,8)),function(card){return _c('card',{key:("deck-" + card),attrs:{"card":card}})}),_vm._v("\n    ...\n  ")]}},{key:"gameable.player_hand",fn:function(ref){
var gameable = ref.item.gameable;
return _vm._l((gameable.player_hand),function(card){return _c('card',{key:("player-" + card),attrs:{"card":card}})})}},{key:"gameable.player_score",fn:function(ref){
var gameable = ref.item.gameable;
return [_vm._v("\n    "+_vm._s(gameable.player_score)+"\n  ")]}},{key:"gameable.banker_hand",fn:function(ref){
var gameable = ref.item.gameable;
return _vm._l((gameable.banker_hand),function(card){return _c('card',{key:("banker-" + card),attrs:{"card":card}})})}},{key:"gameable.banker_score",fn:function(ref){
var gameable = ref.item.gameable;
return [_vm._v("\n    "+_vm._s(gameable.banker_score)+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }